import { Grid } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import { STORY_ASPECT_RATIO } from '~/constants';
import { contentType } from '~/types';
import { isVideoAsset } from '~/utils';

import { LazyImage } from '../LazyImage';
import { LazyVideo } from '../LazyVideo';
import { PlayIcon } from '../icons';

const propTypes = {
  story: contentType,
  alt: PropTypes.string,
  contentPreviewedId: PropTypes.string,
  canPlayVideo: PropTypes.bool,
};

const StoryPreviewCard = ({
  story,
  contentPreviewedId,
  canPlayVideo,
  alt = 'Story preview',
  ...rest
}) => {
  const [asset] = story.assets || [];
  const isVideo = isVideoAsset(asset);

  const lazyImageProps = {};

  if (!isVideo) {
    lazyImageProps.fallbackSrc = asset?.url;
  }

  return (
    <Grid borderRadius="lg" overflow="hidden" {...rest}>
      {isVideo && canPlayVideo ? (
        <LazyVideo
          ratio={STORY_ASPECT_RATIO}
          containerProps={{ id: contentPreviewedId }}
          src={asset?.url}
          videoProps={{ alt, poster: asset.previewUrl }}
        />
      ) : (
        <>
          {isVideo && (
            <PlayIcon
              color="white"
              boxSize="30px"
              positon="absolute"
              justifySelf="center"
              alignSelf="center"
              gridArea="1 / 1 / 2 / 2"
              zIndex={1}
            />
          )}
          <LazyImage
            ratio={STORY_ASPECT_RATIO}
            src={asset?.previewUrl}
            gridArea="1 / 1 / 2 / 2"
            imageProps={{ alt, id: contentPreviewedId }}
            {...lazyImageProps}
          />
        </>
      )}
    </Grid>
  );
};

StoryPreviewCard.propTypes = propTypes;

export default StoryPreviewCard;
